export const wordBreak = {
  normal: 'break-normal',
  breakWord: 'break-words',
  breakAll: 'break-all',
}
export type WordBreak = keyof typeof wordBreak
